module.exports = __webpack_public_path__ + "static/media/zambia-flag-round-small.d041ba5f.jpg";